import http from '@/plugins/axios/axios';
import { CHVAE_TOKEN } from '@/global';

export default class LogsManutencaoService {

    constructor() {
        this.baseUrl = process.env.VUE_APP_BASE_URL_MANUTE
        this.token = JSON.parse(sessionStorage.getItem(CHVAE_TOKEN)); 
    }

    losgManutencao(dataInicio, dataFinal) {       
        return http.request({
            method: 'get', 
            headers: {Authorization: 'Bearer '+this.token.valor},
            url: this.baseUrl + '/statusServicos?dataInicio='+dataInicio+'&dataFinal='+dataFinal
        });
    }

    statusFila() {       
        return http.request({
            method: 'get', 
            headers: {Authorization: 'Bearer '+this.token.valor},
            url: this.baseUrl + '/statusServicos/statusFila'
        });
    }

    buscarDocumentosAnalise(status, tipoAnalise, pagina, quantidade) {       
        return http.request({
            method: 'get', 
            headers: {Authorization: 'Bearer '+this.token.valor},
            url: this.baseUrl + `/statusServicos/documentos?status=${status}&tipoAnalise=${tipoAnalise}&pagina=${pagina}&quantidade=${quantidade}`
        });
    }

    buscarLotesAnalise(status, tipoAnalise, pagina, quantidade) {       
        return http.request({
            method: 'get', 
            headers: {Authorization: 'Bearer '+this.token.valor},
            url: this.baseUrl + `/statusServicos/lotes?status=${status}&tipoAnalise=${tipoAnalise}&pagina=${pagina}&quantidade=${quantidade}`
        });
    }

    finalizarDocumentosParaExcluir(id, status, tipoAnalise) {        
        let url = `/statusServicos/documentos?status=${status}&tipoAnalise=${tipoAnalise}`;
        if(id) {
            url = `/statusServicos/documentos?id=${id}`;
        }
        return http.request({
            method: 'put', 
            headers: {Authorization: 'Bearer '+this.token.valor},
            url: this.baseUrl + url
        });
    }

    finalizarLotesParaExcluir(id, status, tipoAnalise) {
        let url = `/statusServicos/lotes?status=${status}&tipoAnalise=${tipoAnalise}`;
        if(id) {
            url = `/statusServicos/lotes?id=${id}`;
        }
        return http.request({
            method: 'put', 
            headers: {Authorization: 'Bearer '+this.token.valor},
            url: this.baseUrl + url
        });
    }

    reenviarLotesParaFila(id, status, tipoAnalise) {
        let url = `/statusServicos/lotes/reenviarParaFila?status=${status}&tipoAnalise=${tipoAnalise}`;
        if(id) {
            url = `/statusServicos/lotes/reenviarParaFila?id=${id}`;
        }
        return http.request({
            method: 'put', 
            headers: {Authorization: 'Bearer '+this.token.valor},
            url: this.baseUrl + url
        });
    }
}